import moment from "moment";

export default (elt) => ({
  title: elt.title
    ? elt.title.length > 50
      ? `${elt.title.replace(/\-/, " ").substring(0, 50)}...`
      : elt.title
    : elt.name,
  thumbNail: elt.imageUrl || elt.coverPhoto,
  status: elt.status,
  author: elt.author?.name || elt.author?.id || "-",
  summary: elt.summary,
  postDate: moment(elt.publishedAt).format("ll"),
  updated: moment(elt.updatedAt).format("ll"),
  id: elt.id || elt._id,
  file: elt.pdfUrl || "",
});

export const folderDate = new Date()
  .toISOString()
  .replace("-", "")
  .substring(0, 6);
